// SwiperJS
import SwiperCore, { Autoplay, Navigation } from "swiper";

// SwiperJS react components
import { Swiper, SwiperSlide } from "swiper/react";

// SwiperJS styles
import "swiper/swiper.min.css";
import "swiper/css/navigation";

// Pricing page components
import SliderHeader from "pages/about-us/company/Career/components/Header";

// Images
import bg1 from "assets/images/backgrounds/career_challenge.png";
import bg2 from "assets/images/backgrounds/career_work.png";
import bg3 from "assets/images/backgrounds/career_flexible.png";

function Header() {
  // Install SwiperJS modules
  SwiperCore.use([Autoplay, Navigation]);

  const slides = [
    {
      image: bg1,
      label: "Proyectos Desafiantes",
      title: "Que cada día sea un nuevo desafío",
      description: "Nuestra variedad de proyectos desafiantes y emocionantes te brinda la oportunidad de aprovechar al máximo tus capacidades, una fuente de motivación verdaderamente convincente.",
      cards: [
        {
          variant: "gradient",
          color: "info",
          icon: "shuffle",
          title: "Los proyectos más exigentes",
          description: "En nuestro entorno dinámico, atendemos las necesidades de nuestros clientes más exigentes. Estas personas, que buscan los más altos estándares de servicio, nos desafían a superar continuamente las expectativas. Sus demandas únicas alimentan nuestro compromiso con la innovación y la excelencia, impulsándonos a ofrecer resultados excepcionales.",
        },
        {
          variant: "contained",
          color: "info",
          icon: "beenhere",
          title: "La formación y el equipo lo son todo",
          description: "Enfatizando la importancia de la formación y fomentando un fuerte espíritu de equipo, creemos firmemente que estos dos factores forman la base de nuestro éxito. Nuestra dedicación al aprendizaje continuo y la fortaleza cohesiva de nuestro equipo nos permiten sobresalir en cada esfuerzo.",
        },
        {
          variant: "contained",
          color: "info",
          icon: "alarm_off",
          title: "Solo tenemos una vida",
          description: "Con una perspectiva resuelta, reconocemos la importancia de vivir una vida singular. Esta comprensión sustenta nuestro enfoque para maximizar cada oportunidad, impulsándonos a lograr, innovar y aprovechar al máximo nuestra preciosa existencia.",
        },
      ],
    },
    {
      image: bg2,
      label: "Nuestro Equipo",
      title: "Trabaja con los mejores",
      description: "Nos consideramos afortunados de funcionar dentro de un entorno de equipo armonioso y enriquecedor. Esta atmósfera colaborativa se enriquece aún más con nuestro compromiso con la formación y la educación continuas, que juegan un papel fundamental en acelerar significativamente nuestro avance técnico.",
      cards: [
        {
          variant: "contained",
          color: "info",
          icon: "shuffle_on",
          title: "Los proyectos más exigentes",
          description: "En nuestro entorno dinámico, atendemos las necesidades de nuestros clientes más exigentes. Estas personas, que buscan los más altos estándares de servicio, nos desafían a superar continuamente las expectativas. Sus demandas únicas alimentan nuestro compromiso con la innovación y la excelencia, impulsándonos a ofrecer resultados excepcionales.",
        },
        {
          variant: "gradient",
          color: "info",
          icon: "beenhere",
          title: "La formación y el equipo lo son todo",
          description: "Enfatizando la importancia de la formación y fomentando un fuerte espíritu de equipo, creemos firmemente que estos dos factores forman la base de nuestro éxito. Nuestra dedicación al aprendizaje continuo y la fortaleza cohesiva de nuestro equipo nos permiten sobresalir en cada esfuerzo.",
        },
        {
          variant: "contained",
          color: "info",
          icon: "alarm_off",
          title: "Solo tenemos una vida",
          description: "Con una perspectiva resuelta, reconocemos la importancia de vivir una vida singular. Esta comprensión sustenta nuestro enfoque para maximizar cada oportunidad, impulsándonos a lograr, innovar y aprovechar al máximo nuestra preciosa existencia.",
        },
      ],
    },
    {
      image: bg3,
      label: "Trabajo Remoto",
      title: "Arreglos de Trabajo Flexibles",
      description: "Ofrecemos la flexibilidad del trabajo remoto y opciones de horarios adaptables, empoderando a nuestros técnicos para configurar sus horas de trabajo según sus preferencias y estilo de vida individuales.",
      cards: [
        {
          variant: "contained",
          color: "info",
          icon: "shuffle_on",
          title: "Los proyectos más exigentes",
          description: "En nuestro entorno dinámico, atendemos las necesidades de nuestros clientes más exigentes. Estas personas, que buscan los más altos estándares de servicio, nos desafían a superar continuamente las expectativas. Sus demandas únicas alimentan nuestro compromiso con la innovación y la excelencia, impulsándonos a ofrecer resultados excepcionales.",
        },
        {
          variant: "contained",
          color: "info",
          icon: "beenhere",
          title: "La formación y el equipo lo son todo",
          description: "Enfatizando la importancia de la formación y fomentando un fuerte espíritu de equipo, creemos firmemente que estos dos factores forman la base de nuestro éxito. Nuestra dedicación al aprendizaje continuo y la fortaleza cohesiva de nuestro equipo nos permiten sobresalir en cada esfuerzo.",
        },
        {
          variant: "gradient",
          color: "info",
          icon: "alarm_off",
          title: "Solo tenemos una vida",
          description: "Con una perspectiva resuelta, reconocemos la importancia de vivir una vida singular. Esta comprensión sustenta nuestro enfoque para maximizar cada oportunidad, impulsándonos a lograr, innovar y aprovechar al máximo nuestra preciosa existencia.",
        },
      ],
    },
  ];

  return (
    <Swiper autoplay={{ delay: 5000 }} speed={800} spaceBetween={0} slidesPerView={1} navigation loop>
      {slides.map((slide, index) => (
        <SwiperSlide key={index}>
          <SliderHeader
            image={slide.image}
            label={slide.label}
            title={slide.title}
            description={slide.description}
            cards={slide.cards}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export default Header;